import React from 'react'
import { Form } from 'semantic-ui-react'

export default class DescriptionField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props

    return (
      <Form.TextArea
        label="Description"
        required
        placeholder="e.g blah blah blah...."
        onChange={e => onChange('description', e.target.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/fields/descriptionField.js